export default import.meta.ROLLDOWN_FILE_URL_NXK6hZn9IzZhMRlQttotEg